import { render, staticRenderFns } from "./new-cart-billing-address-modal.vue?vue&type=template&id=3ffdc8bf&"
import script from "./new-cart-billing-address-modal.vue?vue&type=script&lang=js&"
export * from "./new-cart-billing-address-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports